type RuntimeConfig = {
  backendOrigin?: string
  chainBuilderOrigin?: string
}

declare global {
  interface Window { __ONLYROSE_CONFIG__?: RuntimeConfig }
}

const runtime = typeof window !== 'undefined' ? (window.__ONLYROSE_CONFIG__ || {}) : {}
const trim = (value?: string) => String(value || '').trim().replace(/\/$/, '')

export const BACKEND_ORIGIN = trim(runtime.backendOrigin || import.meta.env.VITE_ONLYROSE_BACKEND_ORIGIN)
export const CHAIN_BUILDER_ORIGIN = trim(runtime.chainBuilderOrigin || import.meta.env.VITE_ONLYROSE_CHAIN_BUILDER_ORIGIN || BACKEND_ORIGIN)
export const REOWN_PROJECT_ID = String(import.meta.env.VITE_REOWN_PROJECT_ID || '4d12df749060747033a1773b9a4512f2').trim()
export const APP_ORIGIN = typeof window !== 'undefined' ? window.location.origin : 'https://www.onlyrosenft.com'

export const withOrigin = (path: string, origin = BACKEND_ORIGIN) => {
  if (!path) return path
  if (/^https?:\/\//i.test(path)) return path
  return `${origin}${path}`
}

export const apiUrl = (path: string) => withOrigin(path.startsWith('/api/') ? path : `/api/v1${path.startsWith('/') ? path : `/${path}`}`)
export const chainUrl = (path: string) => withOrigin(path.startsWith('/chain-builder/') ? path : `/chain-builder${path.startsWith('/') ? path : `/${path}`}`, CHAIN_BUILDER_ORIGIN)
